import { memo } from 'react'
import { styled } from '@mui/material'
import { AppInverseIcon } from '@weblite/icons'
import { showChatListToolboxModal } from '$comp/modals/chat-list-toolbox'
import { useShouldShowFabButton } from '$logic/client-device'
import { FabButton } from '$logic/client-device/fab-buttons'
import { useIsChatListGoingDown } from '$comp/_app/components/leftPanel/components/chat-list/react-hooks'
import { ChatListFab } from '$comp/_app/components/leftPanel/components/chat-list/components/shared/fab'
import { clsx } from 'clsx'

const Fab = styled(ChatListFab)`
  bottom: 12px;
  left: 12px;
`

export const ToolboxFab = memo(() => {
  const [show] = useShouldShowFabButton([FabButton.TOOLBOX])
  const isChatListGoingDown = useIsChatListGoingDown()

  if (!show) return null

  return (
    <Fab
      className={clsx({ hide: isChatListGoingDown })}
      color="neutralDark"
      onClick={showChatListToolboxModal}
    >
      <AppInverseIcon sx={{ color: 'inherit' }} />
    </Fab>
  )
})
